/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:23
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('HrTeamCtrl', ["$rootScope", "$scope", "$dialog", "$filter", "HumanResource",
                "HumanResourceView", "HumanResourceData", "LanguageManager", "$timeout", "Auth", "Genders", "SiteData",
        function($rootScope,$scope,$dialog,$filter,HumanResource,HumanResourceView,HumanResourceData, LanguageManager, $timeout, Auth, Genders, SiteData)
{
    $scope.displayModificationMessage = false;
    $scope.displayError = false;
    $scope.dd.loading = false;
    $scope.hrIsLoading = false;
    $scope.dd.flowConfig = {
        target: '/rest/companyImageUpload',
        method:'octet',
        query : {companyCode: Auth.getCompanyCode(),type:'humanResource'},
        maxChunkRetries: 1,
        chunkRetryInterval: 5000,
        simultaneousUploads: 1,
        chunkSize : 1024*1024*5,
        singleFile: true,
        testChunks:false,
        headers: {Authorization: $scope.ad.currentUser.token}
    };
    $scope.dd.view.tab = 0;
    $scope.dd.view.imageUploadRunning = false;
    $scope.dd.view.genders = Genders;

    $scope.changeOrderDown = function(hrView)
    {
        var index = $scope.dd.view.humanResourcesActiveView.indexOf(hrView);
        // put a human resource up in the order
        if (index > 0 && index !=-1)
            $scope.dd.view.humanResourcesActiveView[index-1].order++;
        hrView.order--;

        $scope.sortHrActiveViewArray();
    };
    $scope.changeOrderUp = function(hrView)
    {
        // put a human resource down in the order
        var index = $scope.dd.view.humanResourcesActiveView.indexOf(hrView);
        // put a human resource up in the order
        if (index < ($scope.dd.view.humanResourcesActiveView.length-1) && index !=-1)
            $scope.dd.view.humanResourcesActiveView[index+1].order--;
        hrView.order++;

        $scope.sortHrActiveViewArray();
    };

    $scope.openDeletedHrViewConfirmDialog  = function()
    {
        if ($scope.dd.edited.hrView) {
            if ($scope.dd.edited.hrView.id === SiteData.defaultSite.ownerId) {
                  var opts = {
                              backdrop: true,
                              keyboard: true,
                              backdropClick: false,
                              templateUrl: '/partials/global/infoDialog.html',
                              controller: 'DialogCtrl',
                              resolve: {
                                  dialogsModel: function () {
                                      var tableModel = [];
                                      tableModel["label"] = "Impossible de supprimer ce personnel car il est gestionnaire du site.";
                                      return tableModel;
                                  }
                              }
                          };
                          $dialog.dialog(opts).open();
            } else {
              var opts = {
                            backdrop: true,
                            keyboard: true,
                            backdropClick: false,
                            templateUrl:  '/partials/global/removeConfirm.html',
                            controller: 'DialogCtrl' ,
                            resolve: {
                                dialogsModel: function() {
                                    var tableModel = [] ;
                                    tableModel["label"] = $scope.dd.edited.hrView.label;
                                    return tableModel;
                                }}};

                        var d = $dialog.dialog(opts);
                        d.open().then(function(result){
                            if (result)
                                $scope.removeEditedHrView();
                        });
            }
        }
    };
    $scope.setEditedHrView   = function(hrView)
    {
        if ($scope.dd.edited.hrView && $scope.dd.edited.hrView.isChanged())
        {
            $scope.displayChangeMsg = true;
            return;
        }

        $scope.dd.edited.hrView = hrView;
    };
    $scope.createHumanResource  = function()
    {
        if ($scope.dd.view.humanResourcesActiveView)
        {
            if ($scope.dd.edited.hrView && $scope.dd.edited.hrView.isChanged())
            {
                $scope.displayChangeMsg = true;
                return;
            }
            var order = $scope.dd.view.humanResourcesActiveView.length;

            var newHrView = new HumanResourceView(null,-1,$scope,order);
            $scope.dd.view.humanResourcesActiveView.push(newHrView);
            $scope.dd.view.humanResourcesView.push(newHrView);
            $scope.dd.edited.hrView = newHrView;
        }

    };
    $scope.cancelEditedHrView   = function()
    {
        /*if ($scope.dd.edited.hrView.getModel() != null)// retrieve old value from server
        {
            $scope.dd.edited.hrView.reloadModel();
        }
        else*/
        if ($scope.dd.edited.hrView.getModel() == null)
        {
            var index = $scope.dd.view.humanResourcesActiveView.indexOf($scope.dd.edited.hrView);
            if (index>=0)
                $scope.dd.view.humanResourcesActiveView.splice(index,1);
        }

        if($scope.isHrArrayOrdered()) {
            // if order value defined good, we can reload model
            for (var i = 0; i < $scope.dd.view.humanResourcesActiveView.length; i++) {
                $scope.dd.view.humanResourcesActiveView[i].reloadModel();
            }
        } else {
            // if order value defined badly, there is no model to reload : redefine order value
            var humanResources = HumanResourceData.getActiveList();
            $scope.dd.view.humanResourcesActiveView = [];
            for (i = 0; i < humanResources.length; i++) {
                // init order with i
                $scope.dd.view.humanResourcesActiveView.push(new HumanResourceView(humanResources[i], HumanResourceData.getIndexOf(humanResources[i]), $scope, i));
            }
        }

        $scope.sortHrActiveViewArray();

        $scope.dd.edited.hrView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.saveEditedHrView = function () {
        $scope.hrIsLoading = true;
        let humanResourcesActiveView = $scope.dd.view.humanResourcesActiveView;
        let promises = [];
        for (let i = 0; i < humanResourcesActiveView.length; i++) {
            promises.push(humanResourcesActiveView[i].updateModelWithPromise());
        }
        Promise.all(promises).finally(() => {
            $timeout(() => {
                $scope.hrIsLoading = false;
            });
        });

        $scope.sortHrActiveViewArray();

        $scope.dd.edited.hrView = null;
        $scope.displayError = false;
        $scope.displayChangeMsg = false;
    };

    $scope.removeEditedHrView  = function()
    {
        if ($scope.dd.edited.hrView)
        {
            if ($scope.dd.edited.hrView.hrIndex!=-1)// retrieve old value from server
                $scope.dd.edited.hrView.removeModel();
            var index = $scope.dd.view.humanResourcesActiveView.indexOf($scope.dd.edited.hrView);
            if (index!=-1)
            {
                $scope.dd.view.humanResourcesActiveView.splice(index,1);
                if ($scope.dd.view.humanResourcesDeletedView)
                    $scope.dd.view.humanResourcesDeletedView.push($scope.dd.edited.hrView)
            }

            var indexStartDelete = index;
            for(var i=indexStartDelete; i<$scope.dd.view.humanResourcesActiveView.length; i++) {
                $scope.dd.view.humanResourcesActiveView[i].order--;
                $scope.dd.view.humanResourcesActiveView[i].updateModel();
            }

            $scope.dd.edited.hrView = null;
            $scope.displayError = false;
            $scope.displayChangeMsg = false;
        }
    };
}]);




// WEBPACK FOOTER //
// ./js/controllers/pro/configuration/hr/hrTeamCtrl.js